import { render, staticRenderFns } from "./CicloAutocontrolloDetail.vue?vue&type=template&id=bbfd35d0&"
import script from "./CicloAutocontrolloDetail.vue?vue&type=script&lang=js&"
export * from "./CicloAutocontrolloDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports